"use client";

import Image from "next/image";
import Link from "next/link";

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="flex flex-col items-center space-y-4 text-center">
        <Image
          src="/icon-512.png"
          alt="Pedile"
          width={64}
          height={64}
          className="rounded-2xl"
        />
        <h1 className="text-xl md:text-2xl font-bold">Algo salió mal</h1>
        <p className="text-sm md:text-xs text-muted-foreground">
          Ocurrió un error inesperado. Podés intentar de nuevo.
        </p>
        <button
          onClick={reset}
          className="rounded-md bg-primary px-4 py-2 text-sm md:text-xs text-primary-foreground hover:bg-primary/90"
        >
          Reintentar
        </button>
        <Link href="/" className="text-primary underline text-sm md:text-xs">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
